import React, { forwardRef } from "react";
import { ITagProps, applyTagStyles } from "../tag/Tag";
import { Box, Tooltip } from "../..";

const CustomTagContainer = forwardRef<any, ITagProps>(function Tag(
  { children, active = false, selected = false, title, variant, ...props },
  ref,
) {
  const tag = (
    <Box
      css={{
        boxSizing: "border-box",
        display: "inline-flex",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        wordBreak: "break-all",
        padding: "0.25rem 0.5rem 0.25rem 0.5rem",
        fontSize: "0.75rem",
        minHeight: "24px",
        backgroundColor: "white",
        textTransform: "uppercase",
        color: "gray.600",
        alignItems: "center",
      }}
      ref={ref}
      as="span"
      {...applyTagStyles({ active, selected, variant })}
      {...props}
      maxWidth={props.maxWidth || "100% !important"}
    >
      {children}
    </Box>
  );

  if (title) {
    return (
      <Tooltip
        aria-label={title}
        label={title}
        fontSize="sm"
        bg="blue.600"
        color="white"
        px={1}
        rounded="sm"
        showDelay={500}
      >
        {tag}
      </Tooltip>
    );
  }

  return tag;
});

export default CustomTagContainer;
